export function continuousSliderEvents() {
	const rows = document.querySelectorAll(".continuous-row");
	if (!rows.length) return;

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				obs.unobserve(entry.target);
				(async () => {
					try {
						const { initContinuousSlider } = await import("./continuous-slider.js");
						initContinuousSlider(entry.target);
					} catch (err) {
						console.error("Failed to load module:", err);
					}
				})();
			});
		},
		{ threshold: 0.1 }
	);
	rows.forEach((row) => observer.observe(row));
}
